import React, { useState, useEffect } from 'react';
import Menu from '../../Header/Menu';
import {
    CssBaseline,
    makeStyles,
    Grid,
    Card,
    CardActionArea,
    CardHeader,
    Avatar,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import StateItem from './StateItem';
import EndpointEdit from "./EndpointEdit";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
    },
    card: {
        width: '100%',
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
        width: 45,
    },
}));

export default function EndpointList() {
    const classes = useStyles();

    const [endpointList, setEndpointList] = useState([]);
    const [currentEndpoint, setCurrentEndpoint] = useState(null);

    const handleLoad = () => {
        fetch(process.env.REACT_APP_API_URL + '/endpoint', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(res => {
                setEndpointList(res);
                handleGetState();
            });
    };

    const handleGetState = () => {
        fetch(process.env.REACT_APP_API_URL + '/endpoint/status', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then((data) => {
                setEndpointList(prevList => {
                    const updatedList = [...prevList];
                    for (let i = 0; i < data.length; i++) {
                        const re = updatedList.find(e => e.mac === data[i].mac.toUpperCase());
                        if (re) {
                            re.status = data[i].status;
                            re.last = data[i].last_ip;
                        }
                    }
                    return updatedList;
                });
            })
            .catch(console.log);
    };

    useEffect(() => {
        handleLoad();
        const interval = setInterval(() => {
            handleGetState();
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const openDialog = (endpoint) => {
        setCurrentEndpoint(endpoint);
    };

    const closeDialog = () => {
        setCurrentEndpoint(null);
    };

    return (
        <React.Fragment>
            <Menu title='Устройства обработки видео' reloadData={handleLoad} />
            <CssBaseline />
            <div className={classes.root}>
                <Grid container spacing={1} style={{ marginTop: 16 }}>
                    {endpointList.map((data, i) => (
                        <Grid container item xs={12} sm={6} md={4} lg={4} xl={2} key={i}>
                            <Card className={classes.card}>
                                <CardActionArea onClick={() => openDialog(data)}>
                                    <CardHeader
                                        avatar={
                                            <Avatar variant="rounded" className={classes.avatar}>
                                                <CheckCircleOutlineIcon />
                                            </Avatar>
                                        }
                                        subheader={
                                            <Typography variant="h5" component="h2">
                                                {data.mac} ({data.name})
                                                <StateItem data={data} />
                                            </Typography>
                                        }
                                    />
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>

            <Dialog open={currentEndpoint !== null} onClose={closeDialog} maxWidth="lg" fullWidth>
                <DialogTitle>{currentEndpoint ? currentEndpoint.mac : ''}</DialogTitle>
                <DialogContent>
                    {currentEndpoint && <EndpointEdit endpointId={currentEndpoint.id} />}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog} color="primary">
                        Закрыть
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
